import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";

export const ImageUpload = ({ value, onChange, label = "Image", testid = "image-upload" }) => {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Uploaded");
    } catch { toast.error("Upload failed"); }
    setLoading(false);
  };

  return (
    <div>
      {label && <label className="caption mb-2 block">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative h-20 w-20 overflow-hidden rounded-md border border-[#2A2A32]">
            <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange("")} className="absolute right-0 top-0 bg-black/70 p-0.5 text-white"><X size={14} /></button>
          </div>
        ) : null}
        <button type="button" onClick={() => ref.current?.click()} disabled={loading}
          className="btn-outline !py-2.5 text-sm" data-testid={testid}>
          {loading ? <Loader2 className="animate-spin" size={16} /> : <><Upload size={15} /> {value ? "Replace" : "Upload"}</>}
        </button>
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={handle} />
      </div>
    </div>
  );
};
